/**
 * 接口域名管理
 */

const api = {
  url: process.env.VUE_APP_JAVA_PATH, // 正式
  zlbUrl: process.env.VUE_APP_ZLB_JAVA_PATH
}
export default {
  api
}
